import { useState } from "react";

import { screenerData } from "./screenerData"
import { QuestionPage } from "./components/QuestionPage"
import { SubmitComponent } from "./components/SubmitPage"
import { Answer } from "./Types"

const content = screenerData.content
const displayName = content.display_name

const section = content.sections[0]
const sectionTitle = section.title
const answers = section.answers
const questions = section.questions
const numQuestions = questions.length


function Screener() {
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [responses, setResponses] = useState<Answer[]>([])
    
    const lastQuestion = currentQuestion >= numQuestions
    
    let progressLabel = ""
    let progressRate = 100 * (currentQuestion + 1) / ( numQuestions + 1)
    if ( !lastQuestion ) {
        progressLabel = `#${currentQuestion + 1} of ${numQuestions}`
    } else {
        progressLabel = "All done!"
        progressRate = 100
    }

    function handleNext(e : any) {
        if (lastQuestion) return

        const value = e.target.value;
        const questionId = questions[currentQuestion].question_id;

        if (!lastQuestion) {
            setCurrentQuestion(currentQuestion + 1)

            // Update or add the answer for this question
            setResponses(prev => {
                const others = prev.filter(ans => ans.question_id !== questionId);
                return [...others, { "question_id" : questionId, value : parseInt(value) }];
            })
        }
    }

    return (
        <div className="Screener  mx-4 my-5">
            <h1>{displayName}</h1>
            <h2>{sectionTitle}</h2>
            <hr />
            { !lastQuestion ?
                <QuestionPage
                    questionTitle={questions[currentQuestion].title}
                    answers={answers}
                    onClick={handleNext}
                    progressLabel={progressLabel}
                    progressRate={progressRate}
                /> :
                <SubmitComponent responses={responses} />
            }
        </div>
  )
}

export default Screener